import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  name: "business-cooperation",
  mixins: [userPopMixin],
  data: function data() {
    return {
      searchForm: {
        count: 20,
        page: 1
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      remarkDialogVisible: false,
      currentRemarkObj: {},
      remarkValue: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    setRemark: function setRemark() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.setBusinessCooperation({
                id: _this2.currentRemarkObj.id,
                action: 3,
                remark: _this2.remarkValue
              });
            case 1:
              _this2.$message.success("操作成功");
              _this2.getData();
              _this2.remarkDialogVisible = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setStatus: function setStatus(row, status) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var confirmText, title;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              confirmText = "";
              title = "";
              if (status == 1) {
                title = "确认跟进";
                confirmText = "是否确认跟进该合作？";
              } else if (status == 2) {
                title = "确认搁置";
                confirmText = "是否确认暂时搁置该合作？";
              }
              _this3.$confirm(confirmText, title, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return _this3.$api.setBusinessCooperation({
                        id: row.id,
                        action: status
                      });
                    case 1:
                      _this3.$message.success("操作成功");
                      _this3.getData();
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }))).catch(function () {});
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.page = 1;
              }
              _this4.tableLoading = true;
              _context5.n = 1;
              return _this4.$api.getBusinessCooperationList(_this4.searchForm);
            case 1:
              res = _context5.v;
              _this4.tableData = res.data;
              _this4.total = res.page.total;
              _this4.tableLoading = false;
              _this4.getUserListByIds(_this4.tableData, "user_id");
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};